var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configure"},[_c('delete-configuration',{attrs:{"data-qa":"delete-configuration"},on:{"remove":function($event){return _vm.$emit('remove')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }